const FilterCustomizations = window.FilterCustomizations = new class {
  /**
   * The selector for finding facets
   */
  getSelector() {
    return '.facets-drawer';
  }

  constructor() {
    this.customizations = {};

    // Watch for new drawers being added to the body
    const observer = new MutationObserver((mutationList, observer) => {
      for (const mutation of mutationList) {
        for (const $node of Array.from(mutation.addedNodes)) {
          if ($node.matches && $node.matches(this.getSelector())) {
            this.apply();
            return;
          }
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
    });
  }
  
  /**
   * Registers a new relation/group of customizations to a filter label
   */
  register(filterLabel, filterCustomizations = {}) {
    this.customizations[filterLabel] = Object.assign(this.customizations[filterLabel] || {}, filterCustomizations);
  }

  /**
   * Applies all of the customizations to the theme
   */
  apply($facets) {
    // When the drawer is not passed, let's apply to all of them individually
    if (!$facets) {
      document.querySelectorAll(this.getSelector())
        .forEach(($facetsDrawer) => {
          this.apply($facetsDrawer);
        });

      return;
    }

    // Ensure the drawer doesn't get applied twice
    if ($facets.getAttribute('data-facet-customizations-applied')) {
      return;
    }
    $facets.setAttribute('data-facet-customizations-applied', 'true');

    const $filterGroups = $facets.querySelectorAll('.facets details.accordion');

    for (const $filterGroup of $filterGroups) {
      const filterName = $filterGroup.querySelector('& > summary span')?.textContent.trim();
      const filterCustomizations = this.customizations[filterName];

      if (!filterCustomizations) {
        continue;
      }

      for (const customizedValue in filterCustomizations) {
        const $label = $filterGroup.querySelector(`label[data-label="${customizedValue}"]`);
        if (!$label) {
          continue;
        }

        const $input = $label.control
        if (!$input) {
          continue;
        }

        const { type, settings } = filterCustomizations[customizedValue];

        let createFunction = null;
        switch (type) {
          case 'color':
            createFunction = this.createColorLabel;
            break;
          case 'image_1':
            createFunction = this.createImageLabel;
            break;
          case 'image_3':
            createFunction = this.createSwatchesLabel;
            break;
        }

        if (createFunction) {
          createFunction.call(this, $input, $label, settings);
        } else {
          console.warn(`Invalid filter type found:`, type, settings);
        }
      }
    }
  }

  /**
   * Creates an icon in a label
   */
  addIconToLabel($label, className) {
    const $icon = document.createElement('span');
    $icon.classList.add('custom-label-icon', className);

    $label.prepend($icon);
    return $icon;
  }

  /**
   * Transforms the provided label into a color label
   */
  createColorLabel($input, $label, { color }) {
    const $icon = this.addIconToLabel($label, 'custom-label-icon-color');
    $icon.style.setProperty('--color', color);
  }

  /**
   * Transforms the provided label into a swatches label
   */
  createSwatchesLabel($input, $label, { image1, image2, image3 }) {
    const $icon = this.addIconToLabel($label, 'custom-label-icon-swatches');
    $icon.style.setProperty('--image-1', `url(${image1})`);
    $icon.style.setProperty('--image-2', `url(${image2})`);
    $icon.style.setProperty('--image-3', `url(${image3})`);
  }

  /**
   * Transforms the provided label into a large single-image label
   */
  createImageLabel($input, $label, { image }) {
    const $icon = this.addIconToLabel($label, 'custom-label-icon-image');
    $icon.style.setProperty('--image', `url(${image})`);
  }
};